import { brandLogos } from "../data";
import { resolveAssetUrl, Section } from "../shared";

/**
 * Horizontally scrolling infinite strip of partner brand logos.
 * Pauses on hover; respects prefers-reduced-motion globally.
 *
 * @returns {import("react").ReactElement}
 */
export function BrandMarquee() {
  const loop = [...brandLogos, ...brandLogos];

  return (
    <Section className="border-line/60 bg-crystal/40 border-y !py-12 md:!py-14">
      <p className="text-muted mb-8 text-center text-xs font-semibold tracking-[0.12em] uppercase">
        Trusted by Thousands of the World&rsquo;s Top Marketers
      </p>
      <div className="relative overflow-hidden mask-[linear-gradient(90deg,transparent,black_10%,black_90%,transparent)]">
        <div className="animate-marquee flex w-max items-center gap-14 hover:[animation-play-state:paused] md:gap-20">
          {loop.map((logo, idx) => (
            <img
              key={`${logo.alt}-${idx}`}
              src={resolveAssetUrl(logo.src)}
              alt={logo.alt}
              loading="lazy"
              className="h-6 w-auto shrink-0 opacity-60 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0 md:h-8"
            />
          ))}
        </div>
      </div>
    </Section>
  );
}
